import request from '../utils/request';

// 溯源查询 (公开，跨公司，baseURL 为 /api)
export const traceApi = {
  query: (productCode) => request.get(`/trace/${productCode}`, { baseURL: '/api' }),
  check: (productCode) => request.get(`/trace/check/${productCode}`, { baseURL: '/api' }),
};

// 超级管理员 (baseURL 为 /api/super)
export const superAuthApi = {
  login: (data) => request.post('/login', data),
  profile: () => request.get('/me'),
};

export const superCompanyApi = {
  list: (params) => request.get('/companies', { params }),
  detail: (id) => request.get(`/companies/${id}`),
  create: (data) => request.post('/companies', data),
  update: (id, data) => request.put(`/companies/${id}`, data),
  delete: (id) => request.delete(`/companies/${id}`),
  resetAdminPassword: (id, data) => request.post(`/companies/${id}/reset-admin-password`, data),
  listAdmins: (companyId) => request.get(`/companies/${companyId}/admins`),
  createAdmin: (companyId, data) => request.post(`/companies/${companyId}/admins`, data),
  updateAdmin: (companyId, adminId, data) => request.put(`/companies/${companyId}/admins/${adminId}`, data),
  toggleAdmin: (companyId, adminId) => request.delete(`/companies/${companyId}/admins/${adminId}`),
};

// 管理员认证 (baseURL 为 /api/{slug})
export const authApi = {
  login: (data) => request.post('/admin/login', data),
  profile: () => request.get('/admin/profile'),
  updatePassword: (data) => request.post('/admin/password', data),
  logout: () => request.post('/admin/logout'),
};

// 批次管理
export const batchApi = {
  list: (params) => request.get('/batches', { params }),
  all: () => request.get('/batches/all/simple'),
  detail: (id) => request.get(`/batches/${id}`),
  create: (data) => request.post('/batches', data),
  update: (id, data) => request.put(`/batches/${id}`, data),
  delete: (id) => request.delete(`/batches/${id}`),
  copy: (id, data) => request.post(`/batches/${id}/copy`, data),
  batchImport: (data) => request.post('/batches/batch-import', data),
};

// 货品管理
export const productApi = {
  list: (params) => request.get('/products', { params }),
  detail: (id) => request.get(`/products/${id}`),
  create: (data) => request.post('/products', data),
  update: (id, data) => request.put(`/products/${id}`, data),
  delete: (id) => request.delete(`/products/${id}`),
  distribute: (data) => request.post('/products/distribute', data),
  getReturns: (params) => request.get('/products/returns', { params }),
  getReturnDetail: (id) => request.get(`/products/returns/${id}`),
  reviewReturn: (id, data) => request.put(`/products/returns/${id}/review`, data),
  getMaintenance: (id) => request.get(`/products/${id}/maintenance`),
  batchCreate: (data) => request.post('/products/batch', data),
  multiBatchImport: (data) => request.post('/products/multi-batch-import', data),
  categories: () => request.get('/products/categories'),
};

// 微信支付配置
export const wechatPayApi = {
  getConfig: () => request.get('/wechat-pay'),
  saveConfig: (data) => request.put('/wechat-pay', data),
};

// 会员卡
export const memberCardApi = {
  list: () => request.get('/member-cards'),
  create: (data) => request.post('/member-cards', data),
  uploadImage: (formData) => request.post('/member-cards/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
};

// 积分商品
export const pointProductApi = {
  list: () => request.get('/point-products'),
  listAll: () => request.get('/point-products/all'),
  create: (data) => request.post('/point-products', data),
  update: (id, data) => request.put(`/point-products/${id}`, data),
  remove: (id) => request.delete(`/point-products/${id}`),
};

// 小程序会员
export const wxMemberApi = {
  list: (params) => request.get('/wx-members', { params }),
  adjustPoints: (id, data) => request.post(`/wx-members/${id}/points`, data),
  transactions: (id) => request.get(`/wx-members/${id}/transactions`),
};

// 首页轮播图（后台管理）
export const bannerApi = {
  list: () => request.get('/banners'),
  create: (data) => request.post('/banners', data),
  update: (id, data) => request.put(`/banners/${id}`, data),
  remove: (id) => request.delete(`/banners/${id}`),
};

// 积分兑换订单（后台管理员）
export const pointRedemptionApi = {
  list: (params) => request.get('/point-redemptions', { params }),
  arrive: (id) => request.put(`/point-redemptions/${id}/arrive`),
  pickup: (id, code) => request.put(`/point-redemptions/${id}/pickup`, { code }),
  cancel: (id) => request.put(`/point-redemptions/${id}/cancel`),
};

// 兑换订单（门店账户，仅本门店）
export const storeRedemptionApi = {
  list: (params) => request.get('/store/redemptions', { params }),
  arrive: (id) => request.put(`/store/redemptions/${id}/arrive`),
  pickup: (id, code) => request.put(`/store/redemptions/${id}/pickup`, { code }),
  cancel: (id) => request.put(`/store/redemptions/${id}/cancel`),
};

// 顾问
export const consultantApi = {
  list: () => request.get('/consultants'),
  create: (data) => request.post('/consultants', data),
  update: (id, data) => request.put(`/consultants/${id}`, data),
  remove: (id) => request.delete(`/consultants/${id}`),
};

// 文件上传
export const uploadApi = {
  uploadImage: (formData) =>
    request.post('/upload/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  uploadProductPhotos: (productId, formData) =>
    request.post(`/upload/product/${productId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  uploadBatchPhotos: (batchId, formData) =>
    request.post(`/upload/batch/${batchId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  uploadJadeTypeImage: (jadeTypeId, formData) =>
    request.post(`/upload/jade-type/${jadeTypeId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  deletePhoto: (photoId) => request.delete(`/upload/photo/${photoId}`),
  deleteJadeTypePhoto: (photoId) => request.delete(`/upload/jade-type-photo/${photoId}`),
  updatePhotoOrder: (photoId, displayOrder) =>
    request.put(`/upload/photo/${photoId}/order`, { displayOrder }),
  updatePhotoDescription: (photoId, description) =>
    request.put(`/upload/photo/${photoId}/description`, { description }),
};

// 萤石云设备管理
export const ys7DeviceApi = {
  list: () => request.get('/ys7-devices'),
  detail: (id) => request.get(`/ys7-devices/${id}`),
  create: (data) => request.post('/ys7-devices', data),
  update: (id, data) => request.put(`/ys7-devices/${id}`, data),
  delete: (id) => request.delete(`/ys7-devices/${id}`),
};

// 料种管理
export const jadeTypeApi = {
  list: (params) => request.get('/jade-types', { params }),
  all: () => request.get('/jade-types/all'),
  detail: (id) => request.get(`/jade-types/${id}`),
  create: (data) => request.post('/jade-types', data),
  update: (id, data) => request.put(`/jade-types/${id}`, data),
  delete: (id) => request.delete(`/jade-types/${id}`),
};

// 门店管理
export const storeApi = {
  list: (params) => request.get('/stores', { params }),
  detail: (id) => request.get(`/stores/${id}`),
  create: (data) => request.post('/stores', data),
  update: (id, data) => request.put(`/stores/${id}`, data),
  delete: (id) => request.delete(`/stores/${id}`),
};

// 门店账户管理
export const storeAdminApi = {
  list: (params) => request.get('/store-admins', { params }),
  detail: (id) => request.get(`/store-admins/${id}`),
  create: (data) => request.post('/store-admins', data),
  update: (id, data) => request.put(`/store-admins/${id}`, data),
  delete: (id) => request.delete(`/store-admins/${id}`),
};

// 门店登录
export const storeAuthApi = {
  login: (data) => request.post('/store/login', data),
  profile: () => request.get('/store/profile'),
};

// 门店货品操作
export const storeProductApi = {
  list: (params) => request.get('/store/products', { params }),
  getAll: (params) => request.get('/store/products/all', { params }),
  detail: (id) => request.get(`/store/products/${id}`),
  sell: (id, data) => request.post(`/store/products/${id}/sell`, data),
  addMaintenance: (id, data) => request.post(`/store/products/${id}/maintenance`, data),
  getMaintenance: (id) => request.get(`/store/products/${id}/maintenance`),
  returnProducts: (data) => request.post('/store/products/return', data),
  getReturns: (params) => request.get('/store/products/returns', { params }),
  getReturnDetail: (orderId) => request.get(`/store/products/returns/${orderId}`),
  updateMaintenance: (productId, id, data) => request.put(`/store/products/${productId}/maintenance/${id}`, data),
  deleteMaintenance: (productId, id) => request.delete(`/store/products/${productId}/maintenance/${id}`),
  customers: (params) => request.get('/store/customers', { params }),
  getStores: () => request.get('/store/stores'),
};

// 部门管理员认证
export const departmentAuthApi = {
  login: (data) => request.post('/department/login', data),
  profile: () => request.get('/department/profile'),
};

// 部门管理员批次操作
export const departmentBatchApi = {
  list: (params) => request.get('/department/batches', { params }),
  detail: (id) => request.get(`/department/batches/${id}`),
  create: (data) => request.post('/department/batches', data),
  copy: (id, data) => request.post(`/department/batches/${id}/copy`, data),
  uploadPhotos: (batchId, formData) =>
    request.post(`/department/batches/${batchId}/photos`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  deletePhoto: (photoId) => request.delete(`/department/photos/${photoId}`),
  updatePhotoDescription: (photoId, description) =>
    request.put(`/department/photos/${photoId}/description`, { description }),
  getBatchProducts: (batchId, params) => request.get(`/department/batches/${batchId}/products`, { params }),
  uploadProductPhotos: (productId, formData) =>
    request.post(`/department/products/${productId}/photos`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  deleteProductPhoto: (photoId) => request.delete(`/department/products/photos/${photoId}`),
  updateProductPhotoDescription: (photoId, description) =>
    request.put(`/department/products/photos/${photoId}/description`, { description }),
  listPresets: () => request.get('/department/photo-type-descriptions'),
  listPresetsByType: (photoType) => request.get(`/department/photo-type-descriptions/type/${photoType}`),
  createPreset: (data) => request.post('/department/photo-type-descriptions', data),
  updatePreset: (id, data) => request.put(`/department/photo-type-descriptions/${id}`, data),
  deletePreset: (id) => request.delete(`/department/photo-type-descriptions/${id}`),
};

// 部门管理 (管理员)
export const departmentApi = {
  list: (params) => request.get('/departments', { params }),
  all: () => request.get('/departments/all'),
  detail: (id) => request.get(`/departments/${id}`),
  create: (data) => request.post('/departments', data),
  update: (id, data) => request.put(`/departments/${id}`, data),
  delete: (id) => request.delete(`/departments/${id}`),
};

// 部门管理员管理 (管理员)
export const departmentAdminApi = {
  list: (params) => request.get('/department-admins', { params }),
  detail: (id) => request.get(`/department-admins/${id}`),
  create: (data) => request.post('/department-admins', data),
  update: (id, data) => request.put(`/department-admins/${id}`, data),
  delete: (id) => request.delete(`/department-admins/${id}`),
};

// 图片描述常用语 (管理员)
export const photoTypeDescriptionApi = {
  list: (params) => request.get('/photo-type-descriptions', { params }),
  create: (data) => request.post('/photo-type-descriptions', data),
  update: (id, data) => request.put(`/photo-type-descriptions/${id}`, data),
  delete: (id) => request.delete(`/photo-type-descriptions/${id}`),
};

// 照片类型管理 (管理员)
export const photoTypeApi = {
  list: (params) => request.get('/photo-types', { params }),
  all: () => request.get('/photo-types/all'),
  detail: (id) => request.get(`/photo-types/${id}`),
  create: (data) => request.post('/photo-types', data),
  update: (id, data) => request.put(`/photo-types/${id}`, data),
  delete: (id) => request.delete(`/photo-types/${id}`),
};

// 品类管理 (管理员)
export const categoryApi = {
  list: (params) => request.get('/categories', { params }),
  all: () => request.get('/categories/all'),
  detail: (id) => request.get(`/categories/${id}`),
  create: (data) => request.post('/categories', data),
  update: (id, data) => request.put(`/categories/${id}`, data),
  delete: (id) => request.delete(`/categories/${id}`),
};

// 客户管理 (管理员)
export const customerApi = {
  list: (params) => request.get('/customers', { params }),
  detail: (id) => request.get(`/customers/${id}`),
  update: (id, data) => request.put(`/customers/${id}`, data),
  delete: (id) => request.delete(`/customers/${id}`),
};

// 系统审计日志
export const auditLogApi = {
  list: (params) => request.get('/audit-logs', { params }),
};

// 二维码扫描
export const qrScanApi = {
  scan: (photoId) => request.post('/qr-scan', { photoId }, { baseURL: '/api' }),
};

// 国检管理员 (baseURL 为 /api/inspection)
export const inspectionApi = {
  login: (data) => request.post('/login', data),
  profile: () => request.get('/me'),
  search: (params) => request.get('/search', { params }),
  productDetail: (id) => request.get(`/products/${id}`),
  exportSearch: (params) => request.get('/export', { params }),
};

// 超管-国检账号管理 (baseURL 为 /api/super)
export const superInspectionApi = {
  list: (params) => request.get('/inspection-admins', { params }),
  create: (data) => request.post('/inspection-admins', data),
  update: (id, data) => request.put(`/inspection-admins/${id}`, data),
  toggle: (id) => request.delete(`/inspection-admins/${id}`),
  resetPassword: (id, data) => request.post(`/inspection-admins/${id}/reset-password`, data),
};

export default {
  trace: traceApi,
  superAuth: superAuthApi,
  superCompany: superCompanyApi,
  auth: authApi,
  batch: batchApi,
  product: productApi,
  upload: uploadApi,
  jadeType: jadeTypeApi,
  ys7Device: ys7DeviceApi,
  store: storeApi,
  storeAdmin: storeAdminApi,
  storeAuth: storeAuthApi,
  storeProduct: storeProductApi,
  departmentAuth: departmentAuthApi,
  departmentBatch: departmentBatchApi,
  department: departmentApi,
  departmentAdmin: departmentAdminApi,
  photoTypeDescription: photoTypeDescriptionApi,
  customer: customerApi,
  auditLog: auditLogApi,
  qrScan: qrScanApi,
};
